import { IAppConfig } from './types';

function loadStaticModules(appConfig: IAppConfig) {
  require('/var/lib/jenkins/workspace/ggsc-prod-dy-cjyx-web/node_modules/build-plugin-ice-request/lib/runtime.js').default(
    { appConfig }
  );
}

export default loadStaticModules;
